import wx from 'weixin-js-sdk';
// eslint-disable-next-line no-unused-vars
import { get,post } from "../api/http";
// import store from "@/store/store";

// 调起微信扫一扫
export function QRCode() {

    wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
            setTimeout(() => {
                let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                return result;
            },1000)
        }
    });

    // let url = window.location.href.split("#")[0];
    //
    // get("/wx/signature",{url: url})
    //     .then(res => {
    //         console.log(res);
    //         if(res) {
    //             // 配置微信api
    //             wx.config({
    //                 debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //                 appId: process.env.VUE_APP_AppID, // 必填，公众号的唯一标识
    //                 timestamp: res.data.timestamp, // 必填，生成签名的时间戳
    //                 nonceStr: res.data.noncestr,   // 必填，生成签名的随机串
    //                 signature: res.data.signature, // 必填，签名，见附录1
    //                 jsApiList: ["scanQRCode"]
    //             });
    //             wx.ready(function () {
    //                 // setTimeout(() => {
    //                     wx.scanQRCode({
    //                         desc: 'scanQRCode desc',
    //                         needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
    //                         // scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
    //                         success: function (res) {
    //                             var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
    //                             alert(result);
    //                         }
    //                     });
    //                 // },5000)
    //             })
    //         }
    //     })
}
